import React from 'react';
import { OFFER_ANCHOR } from '../data/product';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  external?: boolean;
  className?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  external = false,
  className = ''
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`block w-full rounded-md border-b-4 border-voltdark bg-volt px-4 py-3 text-center font-display text-base uppercase leading-tight tracking-wide text-navy shadow-lg transition-[background-color,transform] duration-150 ease-soft hover:bg-[#F5BB1F] active:translate-y-[2px] active:border-b-2 sm:text-xl ${className}`} data-id="element-29" data-mp="2fz21inlqkyw1">
      {children}
    </a>;
}